// extracted by mini-css-extract-plugin
export default {"title":"Modal_title__CnVYo","checkboxRow":"Modal_checkboxRow__3ASes","header":"Modal_header__epWme","actions":"Modal_actions__o-6SU","content":"Modal_content__Q+Nj9"};